import React from "react";
import * as actions from "../actions/actions";
import { connect } from "react-redux";
import get_parameter_by_name from "../legacy/helpers/get_parameter_by_name";
import _isObject from "lodash/isObject";

import { withRouter } from "react-router";

import { COLORS } from "../constants/colors";

import { colors } from "./shared";
import { SearchWrapper, SearchIcon, SearchInput } from "./SiteHeader/styles";

class NounProjectSearch extends React.PureComponent {
    handleKeyup(event) {
        let codes = {
                up: 38,
                down: 40,
                right: 39,
                left: 37,
                enter: 13,
            },
            keyCode = event.keyCode;

        if (keyCode == codes.enter) {
            this.handleFormSubmit(event);
        } else {
            this.setState({
                submitted: false,
            });
        }
    }

    componentWillReceiveProps(nextProps) {
        let { history } = nextProps;

        // Update query in state from url when location changes
        if (
            history &&
            history.location.search != this.state.lastHistorySearch
        ) {
            let newQuery = get_parameter_by_name("q", history.location.search);
            this.setState({
                query: newQuery,
                lastHistorySearch: history.location.search,
            });
        }
    }

    componentDidMount() {
        this.setState({
            lastHistorySearch: this.props.history.location.search,
        });
    }

    constructor(props) {
        super(props);

        this.state = {
            query: props.query,
        };
    }

    setQuery(event) {
        let rawInput = event.target.value;
        this.setState({
            query: rawInput,
        });
    }

    handleFormSubmit = (e) => {
        this.setState({
            submitted: true,
        });

        this.submitSearch(e, this.state.query);
    };

    render() {
        let placeHolder = "Search for anything",
            searchScope;

        if (location.pathname === "/search/collection/") {
            placeHolder = "Search for any collection";
        }
        return (
            <>
                <SearchWrapper>
                    <form
                        action="/search/"
                        type="GET"
                        spellCheck="false"
                        onSubmit={this.handleFormSubmit}
                    >
                        <SearchIcon fillColor={colors.brownishGrey} />
                        <SearchInput
                            name="q"
                            placeholder={placeHolder}
                            onChange={this.setQuery.bind(this)}
                            onKeyUp={this.handleKeyup.bind(this)}
                            value={this.state.query}
                            spellCheck="false"
                            ref={(input) => {
                                this.searchInput = input;
                            }}
                            data-test-id="search-input"
                        />
                        <div className="search-scope-container">
                            {searchScope}
                        </div>
                        <input
                            type="submit"
                            style={{
                                position: "absolute",
                                left: "-9999px",
                                width: "1px",
                                height: "1px",
                            }}
                            tabIndex="-1"
                        />
                    </form>
                </SearchWrapper>
            </>
        );
    }

    submitSearch(e, query, icon_id, clicked = false) {
        e.preventDefault();
        if (this.state.submitted) {
            return null;
        }
        let searchTerm = encodeURIComponent(query);

        let { location } = this.props.history;

        let searchURL;
        let collectionSearchUrl = "/search/collection/";
        if (location.pathname == collectionSearchUrl) {
            searchURL = `/search/collection/?q=${searchTerm}`;
        } else {
            searchURL = `/search/?q=${searchTerm}`;
        }

        if (icon_id) {
            // Icon ID wins over all, when someone clicks suggestion
            searchURL = `/icon/${icon_id}/`;
            return this.props.redirect(searchURL);
        }
        if (
            location.pathname != "/search/" ||
            !this.props.resultsComponentPresent
        ) {
            this.props.redirect(searchURL);
        } else {
            this.props.history.push(searchURL);

            this.setState({
                submitted: true,
                query,
                lastHistorySearch: null,
            });

            this.props.pageview(searchURL);
        }
    }
}

function mapStateToProps(state, props) {
    let creator, creator_id, collection, query, result_type, scope, scope_id;
    let { viewport, search } = state;
    let { resultsComponentPresent } = search;
    let { location } = props;
    query = get_parameter_by_name("q", location.search) || "";
    creator = get_parameter_by_name("creator", location.search) || "";
    collection = get_parameter_by_name("collection", location.search) || "";

    if (creator) {
        scope = "creator";
        scope_id = creator;
    } else if (collection) {
        scope = "collection";
        scope_id = collection;
    } else if (state.icons.scope) {
        ({ scope, scope_id } = state.icons);
    } else if (_isObject(props.scope)) {
        ({ scope, scope_id } = props.scope);
    }

    return {
        creator,
        creator_id,
        collection,
        query,
        result_type,
        scope,
        scope_id,
        viewport,
        resultsComponentPresent,
    };
}

const NounProjectSearchWrapped = connect(mapStateToProps, {
    redirect: actions.redirect,
    pageview: actions.pageview,
})(NounProjectSearch);

export default withRouter(NounProjectSearchWrapped);
